// product-card-slider.js
(function () {
  function wireNav(swiper, container) {
    var prevEl = container.querySelector('.pcard-prev');
    var nextEl = container.querySelector('.pcard-next');
    var paginationEl = container.querySelector('.product-card-pagination'); // optional

    // Only wire nav if we actually have >1 slide
    if (!swiper || (swiper.slides && swiper.slides.length <= 1)) return;

    // Rebind navigation on an existing swiper instance
    if (swiper.navigation) {
      // tear down old nav bindings (if any)
      try { swiper.navigation.destroy(); } catch (e) {}
      // set new elements
      swiper.params.navigation = { prevEl: prevEl || null, nextEl: nextEl || null };
      // re-init and update
      swiper.navigation.init();
      swiper.navigation.update();
    }

    // (Optional) bullets if present; ignores if not there
    if (paginationEl && swiper.pagination) {
      try { swiper.pagination.destroy(); } catch (e) {}
      swiper.params.pagination = { el: paginationEl, clickable: true };
      swiper.pagination.init();
      swiper.pagination.update();
    }
  }

  function initOrUpgrade(container) {
    // Respect data-loop
    var loopAttr = container.getAttribute('data-loop');
    var loop = (loopAttr === 'true');

    // If Swiper already exists, just re-wire nav/pagination
    if (container.swiper) {
      wireNav(container.swiper, container);
      container.__pcardSwiper = container.swiper;
      return;
    }

    // Only init if there’s more than one slide
    var slides = container.querySelectorAll('.swiper-slide');
    if (!slides || slides.length <= 1) return;

    // Fresh init scoped to this container element
    var swiper = new Swiper(container, {
      loop: loop,
      slidesPerView: 1,
      speed: 300,
      spaceBetween: 2,
      preloadImages: true,
      watchSlidesProgress: true,
      simulateTouch: true,
      allowTouchMove: true,
      // nav/pagination are wired after init so we can handle both new and existing cases uniformly
    });

    wireNav(swiper, container);
    container.__pcardSwiper = swiper;
  }

  function bootstrap(root) {
    // Target each product card slider independently
    var containers = root.querySelectorAll('.product-card .product-card-js, .product-card-js');
    containers.forEach(function (container) {
      // avoid double work in the same pass
      if (container.__pcardWired) return;
      initOrUpgrade(container);
      container.__pcardWired = true;
    });
  }

  document.addEventListener('DOMContentLoaded', function () { bootstrap(document); });
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target || document); });
})();